export interface ICasaDetails {
  casaCountries?: any[];
  casaEmploymentStatuses?: any[];
  casaNationalities?: any[];
  casaOccupations?: any[];
  casaSourceOfIncomes?: any[];
}

export interface ICasaNationalities {
  casaNationalityCode: string;
  casaNationalityDesc: string;
}

export interface ICasaCountries {
  casaCountryCode: string;
  casaCountryDesc: string;
}

export interface ICasaEmploymentStatuses {
  casaEmploymentStatusCode: string;
  casaEmploymentStatusDesc: string;
}

export interface ICasaOccupations {
  casaOccupationCode: string;
  casaOccupationDesc: string;
}

export interface ICasaSourceOfIncomes {
  casaSourceOfIncomeCode: string;
  casaSourceOfIncomeDesc: string;
}
